import type { QueryResult } from "@apollo/client/react/types/types";

import type { GetSiteV2Query, GetSiteV2QueryVariables } from "../../api/generated/graphql";

import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

export type SiteQueryResult = QueryResult<GetSiteV2Query, GetSiteV2QueryVariables>;
export type SiteQueryRefetch = SiteQueryResult["refetch"];
export type SiteResult = GetSiteV2Query["siteV2"];

export type CurrentSiteState = {
  currentSiteId: number | null;
  currentSite: SiteResult | null;
  hasCurrentSite: boolean;
  currentSiteLoading: boolean;
  currentSiteRefetch: SiteQueryRefetch | null;
};

export type CurrentSiteActions = {
  // setCurrentSiteId: (currentSiteId: number | null) => void;
  setCurrentSiteFetchUpdates: (
    loading: boolean,
    refetch?: SiteQueryRefetch | null,
    currentSite?: SiteResult | null,
  ) => void;
};

const initialState: CurrentSiteState = {
  currentSiteId: null,
  currentSite: null,
  hasCurrentSite: false,
  currentSiteLoading: true,
  currentSiteRefetch: null,
};

export const createCurrentSiteSlice: WaterlyAppStateCreator<CurrentSiteActions, CurrentSiteState> = (
  set,
) => ({
  ...initialState,
  setCurrentSiteFetchUpdates: (loading, refetch, currentSite) => {
    set(
      (state) => {
        // when loading with no site data, such as variable change causing cache miss
        // preserve the previous currentSite to prevent an infinite render loop
        const preservedSite = currentSite ?? (loading ? state.currentSite : null);
        const preservedSiteId = currentSite?.id ?? (loading ? state.currentSiteId : null);

        return {
          currentSiteId: preservedSiteId,
          currentSite: preservedSite,
          hasCurrentSite: !!preservedSite,
          // only show loading when we truly have nothing to show
          // so refetches with preserved site data don't unmount downstream views
          currentSiteLoading: loading && !preservedSite,
          currentSiteRefetch: refetch ?? null,
        };
      },
      undefined,
      "currentSite:setCurrentSiteFetchUpdates",
    );
  },
});
